import 'svelte/internal/disclose-version';

Forgot[$.FILENAME] = 'src/pages/Forgot.svelte';

import * as $ from 'svelte/internal/client';
import Field from "../components/Field.svelte";
import api from "../lib/api.js";

var root = $.add_locations($.from_html(`<div class="mark svelte-uh2it9" aria-hidden="true">✉️</div> <h1 class="svelte-uh2it9">Check your inbox</h1> <p class="sub svelte-uh2it9">If we know that address, a reset link is on its way. It's good for one hour.</p> <a class="primary svelte-uh2it9" href="/login">Back to log in</a>`, 1), Forgot[$.FILENAME], [[24, 6], [25, 6], [26, 6], [27, 6]]);
var root_1 = $.add_locations($.from_html(`<h1 class="svelte-uh2it9">Reset your password</h1> <p class="sub svelte-uh2it9">Tell us the email on your account and we'll send a link.</p> <form class="svelte-uh2it9"><!> <button class="primary svelte-uh2it9" type="submit"> </button></form> <p class="links svelte-uh2it9"><a href="/login" class="svelte-uh2it9">Back to log in</a></p>`, 1), Forgot[$.FILENAME], [[29, 6], [30, 6], [31, 6, [[33, 8]]], [35, 6, [[35, 23]]]]);
var root_2 = $.add_locations($.from_html(`<div class="auth svelte-uh2it9"><div class="card svelte-uh2it9"><!></div></div>`), Forgot[$.FILENAME], [[21, 0, [[22, 2]]]]);

const $$css = {
	hash: 'svelte-uh2it9',
	code: '\n  .auth.svelte-uh2it9 { display: grid; place-items: center; padding: 56px 0 72px; }\n  .card.svelte-uh2it9 {\n    width: min(420px, 100%);\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius-lg);\n    padding: 32px;\n    box-shadow: var(--shadow);\n  }\n  h1.svelte-uh2it9 { font-size: 1.6rem; }\n  .sub.svelte-uh2it9 { margin: 8px 0 22px; color: var(--ink-soft); line-height: 1.55; font-size: 0.94rem; }\n  .mark.svelte-uh2it9 { font-size: 2.6rem; }\n  form.svelte-uh2it9 { display: flex; flex-direction: column; gap: 14px; }\n  .primary.svelte-uh2it9 {\n    display: inline-block;\n    text-align: center;\n    background: var(--accent);\n    color: #fff;\n    border: none;\n    font-weight: 600;\n    padding: 13px;\n    border-radius: var(--radius-pill);\n    cursor: pointer;\n    margin-top: 4px;\n  }\n  .primary.svelte-uh2it9:hover:not(:disabled) { background: var(--accent-dark); }\n  .links.svelte-uh2it9 { margin: 18px 0 0; font-size: 0.88rem; }\n  .links.svelte-uh2it9 a:where(.svelte-uh2it9) { color: var(--accent); font-weight: 600; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Forgot($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Forgot);
	$.append_styles($$anchor, $$css);

	let email = $.tag($.state(""), 'email');
	let sent = $.tag($.state(false), 'sent');
	let busy = $.tag($.state(false), 'busy');

	async function submit(event) {
		event.preventDefault();
		$.set(busy, true);

		try {
			(await $.track_reactivity_loss(api.forgotPassword($.get(email).trim())))();
		} finally {
			$.set(busy, false);
			$.set(sent, true);
		}
	}

	var $$exports = { ...$.legacy_api() };
	var div = root_2();
	var div_1 = $.child(div);
	var node = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			var fragment = root();

			$.next(6);
			$.append($$anchor, fragment);
		};

		var alternate = ($$anchor) => {
			var fragment_1 = root_1();
			var form = $.sibling($.first_child(fragment_1), 4);
			var node_1 = $.child(form);

			$.add_svelte_meta(
				() => Field(node_1, {
					label: 'Email',
					name: 'email',
					type: 'email',
					required: true,
					autocomplete: 'email',
					get value() {
						return $.get(email);
					},

					set value($$value) {
						$.set(email, $$value, true);
					}
				}),
				'component',
				Forgot,
				32,
				8,
				{ componentTag: 'Field' }
			);

			var button = $.sibling(node_1, 2);
			var text = $.child(button, true);

			$.reset(button);
			$.reset(form);
			$.next(2);

			$.template_effect(() => {
				button.disabled = $.get(busy);
				$.set_text(text, $.get(busy) ? "Sending…" : "Send reset link");
			});

			$.event('submit', form, submit);
			$.append($$anchor, fragment_1);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(sent)) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			Forgot,
			23,
			4
		);
	}

	$.reset(div_1);
	$.reset(div);
	$.append($$anchor, div);

	return $.pop($$exports);
}